import {
  GRUPO_ALTERAR_DETALHES_DA_ESCALA, GRUPO_EDITAR_DETALHES, GRUPO_CONVIDAR_USUARIO, GRUPO_NOVA_ESCALA, GRUPO_GERAR_FOLHA_DE_PONTO, GRUPO_SIMULAR_FOLHA_DE_PONTO, GRUPO_FOLHA_DE_PAGAMENTO, GRUPO_VER_TODOS_OS_PLANTOES, GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA,
  ESCALA_APAGAR, ESCALA_RENOVAR_LINK, ESCALA_COMPARTILHAR, ESCALA_RETIRAR_USUARIO, ESCALA_ALTERAR_PAPEL, ESCALA_VER_PLANTOES_DO_USUARIO,
  DETALHES_PLANTAO_NOVO_PLANTAO, DETALHES_PLANTAO_VER, DETALHES_PLANTAO_APAGAR, DETALHES_PLANTAO_DIVIDIR, DETALHES_PLANTAO_ALTERAR, DETALHES_PLANTAO_PERSONALIZAR_REGISTRO,
} from '@/constants'

//
// PROCESSA A LISTA DE CAPACIDADES QUE SERÁ SALVO NO BANCO
// Usado na tela ManagerUserModal.vue
//

export const processSelectedCapabilities = selectedCapabilities => Object.entries(selectedCapabilities).filter(([_, capabilityStatus]) => !!capabilityStatus === false).map(([capabilityID, _]) => capabilityID)

//
// userGroups = GRUPOS DO USUÁRIO (users/{userID}/grupos)
// groupID = IDENTIFICADOR DO GRUPO A SER PROCESSADO
//

export const processCapabilities = capabilities => {
  return {
    [GRUPO_ALTERAR_DETALHES_DA_ESCALA]: capabilities.indexOf(GRUPO_ALTERAR_DETALHES_DA_ESCALA) === -1,
    [GRUPO_EDITAR_DETALHES]: capabilities.indexOf(GRUPO_EDITAR_DETALHES) === -1,
    [GRUPO_CONVIDAR_USUARIO]: capabilities.indexOf(GRUPO_CONVIDAR_USUARIO) === -1,
    [GRUPO_NOVA_ESCALA]: capabilities.indexOf(GRUPO_NOVA_ESCALA) === -1,
    [GRUPO_GERAR_FOLHA_DE_PONTO]: capabilities.indexOf(GRUPO_GERAR_FOLHA_DE_PONTO) === -1,
    [GRUPO_SIMULAR_FOLHA_DE_PONTO]: capabilities.indexOf(GRUPO_SIMULAR_FOLHA_DE_PONTO) === -1,
    [GRUPO_FOLHA_DE_PAGAMENTO]: capabilities.indexOf(GRUPO_FOLHA_DE_PAGAMENTO) === -1,
    [GRUPO_VER_TODOS_OS_PLANTOES]: capabilities.indexOf(GRUPO_VER_TODOS_OS_PLANTOES) === -1,
    [GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]: capabilities.indexOf(GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES) === -1,
    [GRUPO_CRIAR_ESCALA]: capabilities.indexOf(GRUPO_CRIAR_ESCALA) === -1,
    [GRUPO_ACOMPANHAR_ESCALA]: capabilities.indexOf(GRUPO_ACOMPANHAR_ESCALA) === -1,
    [ESCALA_APAGAR]: capabilities.indexOf(ESCALA_APAGAR) === -1,
    [ESCALA_RENOVAR_LINK]: capabilities.indexOf(ESCALA_RENOVAR_LINK) === -1,
    [ESCALA_COMPARTILHAR]: capabilities.indexOf(ESCALA_COMPARTILHAR) === -1,
    [ESCALA_RETIRAR_USUARIO]: capabilities.indexOf(ESCALA_RETIRAR_USUARIO) === -1,
    [ESCALA_ALTERAR_PAPEL]: capabilities.indexOf(ESCALA_ALTERAR_PAPEL) === -1,
    [ESCALA_VER_PLANTOES_DO_USUARIO]: capabilities.indexOf(ESCALA_VER_PLANTOES_DO_USUARIO) === -1,
    [DETALHES_PLANTAO_NOVO_PLANTAO]: capabilities.indexOf(DETALHES_PLANTAO_NOVO_PLANTAO) === -1,
    [DETALHES_PLANTAO_VER]: capabilities.indexOf(DETALHES_PLANTAO_VER) === -1,
    [DETALHES_PLANTAO_APAGAR]: capabilities.indexOf(DETALHES_PLANTAO_APAGAR) === -1,
    [DETALHES_PLANTAO_DIVIDIR]: capabilities.indexOf(DETALHES_PLANTAO_DIVIDIR) === -1,
    [DETALHES_PLANTAO_ALTERAR]: capabilities.indexOf(DETALHES_PLANTAO_ALTERAR) === -1,
    [DETALHES_PLANTAO_PERSONALIZAR_REGISTRO]: capabilities.indexOf(DETALHES_PLANTAO_PERSONALIZAR_REGISTRO) === -1,
  }
}

export const processUserGroupCapabilities = (userGroups, groupID) => {
  const capabilities = (
    !!userGroups === true &&
    !!groupID === true &&
    !!userGroups[groupID] === true &&
    !!userGroups[groupID].disabledCapabilities === true &&
    Array.isArray(userGroups[groupID].disabledCapabilities) === true
  ) ? userGroups[groupID].disabledCapabilities : []

  return processCapabilities(capabilities)
}
